// 根据域名和 tab 类型获取价格角标文案
export function getTabPriceBadge(type) {
      const isPyjkd = window.location.host === 'www.pyjkd.com'
      let price
      if (type === 'more') {
            price = isPyjkd ? '3.7' : '3.9'
      } else if (type === 'business') {
            price = isPyjkd ? '3.5' : '3.7'
      } else {
            price = isPyjkd ? '3.7' : '3.9'
      }
      return `低至${price}元起`
}
